import { registerReducer } from "core/redux/store";

import { RandomScrambleState } from "./types";
import reducer from "./reducer";

declare module "core/redux/store" {
  interface ApplicationState {
    randomScramble: RandomScrambleState;
  }
}

registerReducer("randomScramble", reducer);
